// Types
import Vue from 'vue';
const NavigationItemsProvider = Vue.extend({
  provide() {
    return {
      navigationItemsProvider: this
    };
  },
  data() {
    return {
      navigationItems: [],
      registeredControllers: [],
      tickets: {}
    };
  },
  methods: {
    registerController(component) {
      const path = [];
      const calcPath = comp => {
        if (comp === this || !comp._uid) return;
        path.push(comp._uid);
        calcPath(comp.$parent);
      };
      calcPath(component);
      this.registeredControllers.push({
        component: component._uid || 0,
        path
      });
      this.calculateTickets();
    },
    unregisterController(component) {
      const {
        _uid
      } = component;
      if (!_uid) return;
      const i = this.registeredControllers.findIndex(controller => controller.component === _uid);
      this.registeredControllers.splice(i, 1);
      this.$delete(this.tickets, _uid);
    },
    calculateTickets() {
      this.registeredControllers.forEach(controller => {
        const _uid = controller.component;
        if (!_uid) return;
        const {
          path
        } = controller;
        const index = this.$children.findIndex(child => child._uid === path[path.length - 1]);
        this.$set(this.tickets, _uid, index);
      });
    }
  }
});
export default NavigationItemsProvider;